import { useRef, useState, useEffect } from 'react'
import { ChevronDown } from 'react-feather'

import {
  Wrapper,
  Label,
  Select,
  Dropdown,
  Option,
  Error,
} from './selectFieldStyle'

const SelectField = ({
  label,
  error,
  options,
  onChange,
  value,
  colors,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef()
  const selectedItemRef = useRef()

  useEffect(() => {
    if (isOpen) selectedItemRef.current?.focus()
  }, [isOpen])

  return (
    <Wrapper>
      {label && <Label htmlFor={props.id}>{label}</Label>}

      <Select
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        data-color={colors ? value : undefined}
        {...props}
      >
        <span>{options[value]}</span>
        <ChevronDown size="1.3em" />
      </Select>

      {isOpen && (
        <Dropdown
          ref={dropdownRef}
          onBlur={e => {
            if (dropdownRef.current.contains(e.relatedTarget) || e.relatedTarget?.id === props.id) return
            setIsOpen(false)
          }}
          role="listbox"
        >
          {Object.keys(options).map((option, i) => (
            <Option
              role="option"
              ref={(Object.keys(options).includes(value) ? option === value : i === 0) ? selectedItemRef : undefined}
              type="button"
              key={option}
              onClick={() => {
                onChange(option)
                setIsOpen(false)
              }}
              data-color={colors ? option : undefined}
              aria-selected={value === option}
            >{options[option]}</Option>
          ))}
        </Dropdown>
      )}

      {error && <Error>{error}</Error>}
    </Wrapper>
  )
}

export default SelectField